<template>
    <p>This about vue router</p>
    <div class="row" >
    <div class="row">
        <p class="col"><div class="col">About us</div></p>
    </div>
    </div>   
</template>